import { render, staticRenderFns } from "./squaread.vue?vue&type=template&id=50f67dc8&scoped=true"
import script from "./squaread.vue?vue&type=script&lang=js"
export * from "./squaread.vue?vue&type=script&lang=js"
import style0 from "./squaread.vue?vue&type=style&index=0&id=50f67dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f67dc8",
  null
  
)

export default component.exports